<template>
    <el-dialog width="852px"
               :visible.sync="isShow"
               title="自定义模型库"
               top="82px"
               append-to-body
               :close-on-click-modal="false">
        <modal-selector v-model="selected"></modal-selector>
        <div class="btns">
            <el-button plain size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm" :style="{marginLeft: '24px'}">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import modalSelector from "./modalSelector";
    export default {
        name: "modalSelectDialog",
        components: {
            modalSelector,
        },
        watch: {
            isShow(val) {
                if (!val) {
                    this.resolve && this.resolve(null);
                    this.resolve = null;
                    this.selected = null;
                }
            }
        },
        data() {
            return {
                selected: null,
                isShow: false,
                resolve: null
            }
        },
        methods: {
            show(data) {
                this.selected = data;
                this.isShow = true;
                return new Promise(resolve => this.resolve = resolve);
            },
            cancel() {
                this.resolve && this.resolve(null);
                this.resolve = null;
                this.isShow = false;
            },
            async confirm() {
                this.resolve && this.resolve(this.selected);
                this.isShow = false;
            },
        }
    }
</script>

<style scoped>
    .btns{
        text-align: center;
        padding-top: 15px;
    }
</style>